/**
 * Used for the certificate creation wizard.
 * @type {{FROM_CSR: string, FROM_EXISTING: string, FROM_NEW_KEYPAIR: string}}
 */
const values = {
  FROM_CSR: "from-csr",
  FROM_EXISTING: "from-existing",
  FROM_NEW_KEYPAIR: "from-new-keypair"
};

export default Object.freeze(values);
